import { render, staticRenderFns } from "./employment-contract-sign.vue?vue&type=template&id=1d5877ae&scoped=true"
import script from "./employment-contract-sign.vue?vue&type=script&lang=js"
export * from "./employment-contract-sign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5877ae",
  null
  
)

export default component.exports